import apiRequest from '../index'

export default {
  path: '/v1/maintenance_pack/subscriptions/updateCar',
  async put (param) {
    await window.callNativeHTTPX()
    return apiRequest.put(`${this.path}`, { ...param }, {
      headers: {
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
